import script from "./QuizzIllustrationMobileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzIllustrationMobileModal.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzIllustrationMobileModal.vue?vue&type=style&index=0&id=b0287f42&lang=scss"

const __exports__ = script;

export default __exports__